import React, { useEffect, Fragment } from "react";
import { Row } from "antd";
import AntSpin from "../../common/AntSpin";
import BarsVertical from "../../common/charts/BarsVertical";
import Line from "../../common/charts/Line";
import IconHelper from "../../common/IconHelper";

function Home({props, profile}){
  
    useEffect(() => {
        const data = {
            userId: localStorage.getItem('@Ossel:userid'), 
            jwt: localStorage.getItem('@Ossel:token'),
            profile
        };
        
        props.GET_DASHBOARD(data);
    }, []);

    if(props.data.data && props.data.data.data){
        return (
            <Fragment>
                <Row>
                    <div style={{background: '#fff', width: "98%"}}>
                        <h2 style={{textAlign: "center", paddingTop: 30, paddingBottom: 15}}>
                            Vouchers Emitidos por Mês&nbsp;&nbsp;&nbsp;
                            <IconHelper title={"Total de vouchers emitidos ao longo do ano"}/>
                        </h2>
                        <BarsVertical 
                            data={props.data.data.data.data[0][0]} 
                            fields={props.data.data.data.data[0][1]}
                        />
                    </div>
                </Row>
                <Row>
                    <div style={{background: '#fff', width: "98%", marginTop: 20, marginBottom: 10}}>
                        <h2 style={{textAlign: "center", paddingTop: 30, paddingBottom: 15}}>
                            Vouchers Emitidos por Sala&nbsp;&nbsp;&nbsp;
                            <IconHelper title={"Total de vouchers emitidos por sala ao longo do ano"}/>
                        </h2>
                        <Line 
                            data={props.data.data.data.data[1][0]} 
                            fields={props.data.data.data.data[1][1]} 
                            axisY="qtd"
                        />
                    </div>
                </Row>
            </Fragment>
        )
    }else return <AntSpin/>
}

export default Home;


// WEBPACK FOOTER //
// ./src/components/general/homeWrapper/Home.jsx